@if(messageView){
<sa-message-view
  [props]="messageView"
  (onClick)="onMessageViewEvent($event)"
></sa-message-view>
}@else{
<div class="sa-form-container">
  @if(toast){
  <sa-toast
    class="block"
    [subHeading]="toast.subHeading || ''"
    [status]="toast.status || 'success'"
  ></sa-toast>
  }
  <div class="title">Reset your password</div>
  <div class="sub-title">
    Enter the work email id associated with your Saras account.
  </div>

  <form class="flex flex-col" [formGroup]="form" (ngSubmit)="onSubmit()">
    <formly-form
      [form]="form"
      [model]="model"
      [fields]="fields"
      (modelChange)="modelChangeHandler($event)"
    >
    </formly-form>

    <!-- [disabled]="!form.valid" -->
    <sa-button
      [isSubmit]="true"
      text="Send password reset link"
      type="primary"
      size="medium"
      state="default"
      width="100%"
    ></sa-button>
  </form>
</div>
}
